import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TOKEN_TABS, type TokenTab } from '@/features/access/access-tabs';
import { TokenDetailPage } from '@/features/access/tokens/token-detail-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Jeton API personnel (`/applications/{id}`) : un seul onglet, le résumé. */
export const Route = createFileRoute('/$tenant/tokens/api/$applicationId')({
  validateSearch: (search: Record<string, unknown>): { tab: TokenTab } => ({
    tab: TOKEN_TABS.parse(search['tab']),
  }),
  component: ApiTokenRoute,
});

function ApiTokenRoute() {
  const { tenant, applicationId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="tokens"
      crumbs={[{ label: t('access.tokens.title') }, { label: applicationId, mono: true }]}
    >
      <TokenDetailPage
        tenantId={tenant}
        kind="api"
        tokenId={applicationId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
